/**
 * Portal Pixels Color Definitions
 *
 * Centralized color definitions with hex values for Portal Pixels v2 theme.
 * Based on Portal Pixels Figma design system:
 * https://www.figma.com/design/7CzvVfV0XqmOkAnSMFnWga/Fold-Forge-Foundation?node-id=0-1&p=f&vars=1&var-id=292-6711&var-set-id=285-6710&m=dev
 */

/**
 * Text color definitions
 */
export const textColors = {
  primary: '#041D33',
  secondary: '#4A5565',
  disabled: '#D9D9D9',
  placeholder: '#A3A3A3',
  buttonDisabled: '#C9D0D9',
  buttonTextDisabled: '#94A1B3',
} as const;

/**
 * Background color definitions
 */
export const backgroundColors = {
  primary: '#FFFFFF',
  secondary: '#EDF3FD',
  tertiary: '#F5F5F5',
  quaternary: '#E5E5E5',
  lightGrey: '#F3F5F7',
  mediumGrey: '#C9D0D9',
  disabled: '#F5F5F5',
  lightBlue: '#F6FAFD',
  mediumBlue: '#EDF3FD',
  mediumDarkBlue: '#B1CEF6',
} as const;

/**
 * Primary color palette (Slate spectrum)
 */
export const primaryColors = {
  '50': '#FAFBFB',
  '100': '#F4F4F5',
  '200': '#C6CACE',
  '300': '#AEB2B9',
  '400': '#A0A6AD',
  '500': '#8E949D',
  '600': '#737B86',
  '700': '#565F6D',
  '800': '#3A4655',
  '900': '#196CDF',
  '950': '#0F151E',

  light: '#1d2a3c1f',
  main: '#196CDF',
  dark: '#012957',
} as const;

/**
 * Secondary color palette (Blue spectrum)
 */
export const secondaryColors = {
  '50': '#EDF3FD',
  '100': '#D6E5FA',
  '200': '#B1CEF6',
  '300': '#88B4F2',
  '400': '#639DED',
  '500': '#3A83E9',
  '600': '#196BDE',
  '700': '#1454AE',
  '800': '#0E3E80',
  '900': '#09264E',
  '950': '#061B37',

  light: '#EDF3FD',
  main: '#0C4A9C',
  dark: '#0E3E80',
} as const;

/**
 * Success color palette
 */
export const successColors = {
  '50': '#EBF9EE',
  '100': '#D6F4DE',
  '200': '#B8ECC5',
  '300': '#85DE9C',
  '400': '#5CD37B',
  '500': '#1CC248',
  '600': '#18A53D',
  '700': '#178113',
  '800': '#12630F',
  '900': '#0E4C0B',
  '950': '#0A3908',

  light: '#E2F8F2',
  main: '#108265',
  dark: '#167D12',
} as const;

/**
 * Warning color palette
 */
export const warningColors = {
  '50': '#FCF7F0',
  '100': '#FFE5B9',
  '200': '#FFD184',
  '300': '#FFC462',
  '400': '#FFBD50',
  '500': '#D9972A',
  '600': '#B85510',
  '700': '#995700',
  '800': '#803E00',
  '900': '#662400',
  '950': '#4D0B00',

  light: '#FFD662',
  main: '#8C621C',
  dark: '#8C621C',
} as const;

/**
 * Error color palette
 */
export const errorColors = {
  '50': '#FFF5F6',
  '100': '#FFDBDF',
  '200': '#FFA3AE',
  '300': '#FF7081',
  '400': '#FF3D54',
  '500': '#FF0A27',
  '600': '#D0021B',
  '700': '#A30013',
  '800': '#7A000E',
  '900': '#4D0009',
  '950': '#330006',

  light: '#EF4444',
  main: '#A30013',
  dark: '#D0021B ',
} as const;

export const borderColors = {
  light: '#EDEFF0',
  main: '#1D2A3C',
  dark: '#D1D5DC',
} as const;

export const infoColors = {
  '50': '#F0FAFF',
  '100': '#d6e5fa',
  '200': '#b1cef6',
  '300': '#88b4f2',
  '400': '#639ded',
  '500': '#3a83e9',
  '600': '#196bde',
  '700': '#1454ae',
  '800': '#1454ae',
  '900': '#09264e',
  '950': '#061b37',
  light: '#A1D1FA',
  main: '#196CDF',
  dark: '#196CDF',
} as const;
